import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { concat, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  switchMap,
  tap,
} from "rxjs/operators";
import { Company } from "src/app/models/Company";
import { CompanyService } from "src/app/services/company.service";

@Component({
  selector: "company-list",
  templateUrl: "./company-list.component.html",
  styleUrls: ["./company-list.component.scss"],
  standalone: false,
})
export class CompanyListComponent implements OnInit {
  companies: Company[];
  companies$: Observable<Company[]>;
  companiesLoading = false;
  companyInput$ = new Subject<string>();
  selectedCompany: Company;
  minLengthTerm = 3;
  @Input() valid: boolean = true;
  @Output() selectionChange: EventEmitter<Company> = new EventEmitter<Company>();

  constructor(private companyService: CompanyService) {}

  ngOnInit(): void {
    this.loadCompanies();
  }

  loadCompanies() {
    this.companies$ = concat(
      of(this.companies), // default items
      this.companyInput$.pipe(
        filter((res) => {
          return res !== null && res?.length >= this.minLengthTerm;
        }),
        distinctUntilChanged(),
        debounceTime(500),
        tap(() => (this.companiesLoading = true)),
        switchMap((term) => {
          return this.companyService.search(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.companiesLoading = false)),
          );
        }),
      ),
    );
  }

  trackByFn(item: Company) {
    return item?.name;
  }
}
